import React from 'react';
import queryString from 'query-string';

function Unavailable(props){

  const parsed = queryString.parse(window.location.search);
  const title = parsed.title;

  return (
    <div style={{textAlign: "center", minHeight: "calc(100vh - 300px)"}}>
        <h1>{props.data}{title}</h1>
        <h2>Oops! Looks like this feature isn't ready yet. Please check back with us later.</h2>
    </div>
  );
};
  
export default Unavailable;